import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { useAuth } from '../auth.jsx';
import { setLanguage } from '../i18n.js';
import i18n from 'i18next';

const navItemClass = ({ isActive }) =>
  `flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors ${
    isActive
      ? 'bg-zinc-800 text-zinc-100'
      : 'text-zinc-400 hover:bg-zinc-900 hover:text-zinc-200'
  }`;

export default function Layout() {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login', { replace: true });
    } catch {
      toast.error('Logout failed');
    }
  };

  const toggleLang = () => {
    setLanguage(i18n.language?.startsWith('en') ? 'fr' : 'en');
  };

  return (
    <div className="h-screen flex bg-zinc-950 text-zinc-100">
      <aside className="w-56 border-r border-zinc-800 flex flex-col">
        <div className="px-4 py-4 border-b border-zinc-800">
          <div className="text-base font-semibold tracking-tight">mpo</div>
          <div className="text-[11px] text-zinc-500 uppercase tracking-wider">{t('layout.tagline')}</div>
        </div>
        <nav className="flex-1 px-2 py-3 space-y-1">
          <NavLink to="/dashboard" className={navItemClass}>{t('nav.dashboard')}</NavLink>
          <NavLink to="/purchase-orders" className={navItemClass}>{t('nav.purchaseOrders')}</NavLink>
          <NavLink to="/subscriptions" className={navItemClass}>{t('nav.subscriptions')}</NavLink>
          {user?.role === 'ADMIN' && (
            <div className="pt-4">
              <div className="px-3 py-1 text-[10px] uppercase tracking-wider text-zinc-600">{t('nav.admin')}</div>
              <NavLink to="/admin/concessions" className={navItemClass}>{t('nav.concessions')}</NavLink>
              <NavLink to="/admin/vendors" className={navItemClass}>{t('nav.vendors')}</NavLink>
              <NavLink to="/admin/departments" className={navItemClass}>{t('nav.departments')}</NavLink>
              <NavLink to="/admin/users" className={navItemClass}>{t('nav.users')}</NavLink>
              <NavLink to="/admin/traffic" className={navItemClass}>{t('nav.traffic')}</NavLink>
              <NavLink to="/admin/settings" className={navItemClass}>{t('nav.settings')}</NavLink>
            </div>
          )}
        </nav>
        <div className="border-t border-zinc-800 p-3 space-y-2">
          <div className="text-xs text-zinc-400 truncate" title={user?.email}>{user?.name}</div>
          <div className="flex items-center justify-between">
            <button onClick={toggleLang} className="text-[11px] text-zinc-500 hover:text-zinc-300 uppercase">
              {i18n.language?.startsWith('en') ? 'FR' : 'EN'}
            </button>
            <button onClick={handleLogout} className="text-[11px] text-zinc-500 hover:text-zinc-300">
              {t('nav.logout')}
            </button>
          </div>
        </div>
      </aside>
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
